/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Parameter_Change_InvalidInputs */

const en_error_parameter_change_invalid = /** @type {(inputs: Error_Parameter_Change_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The value cannot start then.`)
};

/**
* | output |
* | --- |
* | "The value cannot start then." |
*
* @param {Error_Parameter_Change_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_parameter_change_invalid = /** @type {((inputs?: Error_Parameter_Change_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Parameter_Change_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_parameter_change_invalid(inputs)
});